import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  processedReceiptData: {},
  generalReceiptData: {},
  generalReceiptListData: {
    list: {
      data: [],
      total: 0,
    },
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
